/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workspace_DefaultInputs */

const en_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

const fr_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par défaut`)
};

const de_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

const it_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Predefinito`)
};

const ru_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По умолчанию`)
};

const es_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por defecto`)
};

const zh_cn2_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认`)
};

const ja_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デフォルト`)
};

const hi_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गलती करना`)
};

const pt_pt2_workspace_default = /** @type {(inputs: Workspace_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padrão`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Workspace_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const workspace_default = /** @type {((inputs?: Workspace_DefaultInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workspace_DefaultInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_workspace_default(inputs)
	if (locale === "de") return de_workspace_default(inputs)
	if (locale === "it") return it_workspace_default(inputs)
	if (locale === "ru") return ru_workspace_default(inputs)
	if (locale === "es") return es_workspace_default(inputs)
	if (locale === "zh-CN") return zh_cn2_workspace_default(inputs)
	if (locale === "ja") return ja_workspace_default(inputs)
	if (locale === "hi") return hi_workspace_default(inputs)
	if (locale === "pt-PT") return pt_pt2_workspace_default(inputs)
	return en_workspace_default(inputs)
});